import { useStore } from 'react-redux'

export const currencyToSymbol = currency => {
  switch (currency) {
    case 'EUR':
      return '€'
    case 'CHF':
      return 'CHF'
    case 'NONE':
      return null
    default:
      return '€'
  }
}

export const nonBreakableSpace = '\u00A0'

export const formatPriceString = ({
  amount = 0,
  locale,
  currencySymbol,
  decimalPlaces = 2,
  symbolRight = false,
}) => {
  const isNegativeAmount = amount < 0
  const displayAmount = Math.abs(amount)
  let price = displayAmount.toLocaleString(locale, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  })
  if (locale === 'fr-CH') {
    price = price.replace(/,/g, '.')
  }
  return symbolRight
    ? `${
        isNegativeAmount ? '- ' : ''
      }${price}${nonBreakableSpace}${currencySymbol}`
    : `${
        isNegativeAmount ? '- ' : ''
      }${currencySymbol}${nonBreakableSpace}${price}`
}

export const formatPriceStringStoreConnected = ({
  amount = 0,
  currency,
  decimalPlaces = 2,
}) => {
  // TODO for code owners: consider fixing and/or removing this line
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { publicRuntimeConfig } = useStore().getState()
  return formatPriceString({
    amount,
    locale: publicRuntimeConfig.publicConfig.locale,
    currencySymbol: currencyToSymbol(currency),
    decimalPlaces,
    symbolRight: publicRuntimeConfig.publicConfig.currencySymbolRight,
  })
}
